import { useAccessToken } from 'providers/AccessTokenProvider';

export const usePermissions = (requiredPermissions: string[]) => {
  const { permissions, isAdmin } = useAccessToken();
  if (isAdmin) return requiredPermissions?.map(() => true);

  return requiredPermissions?.map(permissionKey =>
    permissions?.some(
      permission => permission?.key === permissionKey && permission?.isActive
    )
  );
};
